import { defineComponent as _defineComponent } from 'vue'
import { appName as appId } from './config.ts'
import { translate as t } from '@nextcloud/l10n'
import {
  NcAppContent,
  NcContent,
  NcEmptyContent,
} from '@nextcloud/vue'
import DynamicSvgIcon from '@rotdrop/nextcloud-vue-components/lib/components/DynamicSvgIcon.vue'
import appIcon from '../img/app.svg?raw'
import {
  ref,
} from 'vue'
import {
  useRoute,
  useRouter,
} from 'vue-router/composables'
import type { Location as RouterLocation } from 'vue-router'
import logger from './logger.ts'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loading = ref(true)
const error = ref<string | undefined>(undefined)

const router = useRouter()
const currentRoute = useRoute()

const onError = (event: { error: Error, hint: string }) => {
  logger.error('Caught an error event', { event })
  error.value = event.hint
  loading.value = false
}

const onIFrameLoaded = async (event: { wikiPath: string[], query: Record<string, string> }) => {
  loading.value = false
  logger.debug('GOT EVENT', { event })
  if (event.query.id) {
    delete event.query.id
  }
  const routerLocation: RouterLocation = {
    name: currentRoute.name!,
    params: {
      wikiPage: event.wikiPath.join(':'),
    },
    query: { ...event.query },
  }
  if (currentRoute.params.wikiPage !== routerLocation.params!.wikiPage
      || JSON.stringify(currentRoute.query) !== JSON.stringify(routerLocation.query)) {
    logger.debug('PUSHING ROUTE', {
      currentRoute,
      routerLocation,
    })
    try {
      await router.push(routerLocation)
    } catch (error) {
      logger.debug('NAVIGATION ABORTED', { error })
    }
  } else {
    logger.debug('ROUTE UNCHANGED, DOING NOTHING')
  }
}

// The initial route is not named and consequently does not load the
// wrapper component, so just replace it by the one and only named
// route.
router.onReady(async () => {
  if (!currentRoute.name) {
    logger.info('CURRENT ROUTE', { currentRoute })
    const routerLocation: RouterLocation = {
      name: 'home',
      params: {},
      query: { ...currentRoute.query },
    }
    try {
      await router.replace(routerLocation)
    } catch (error) {
      logger.debug('NAVIGATION ABORTED', { error })
    }
  }
})

return { __sfc: true,loading, error, router, currentRoute, onError, onIFrameLoaded, appId, t, NcAppContent, NcContent, NcEmptyContent, DynamicSvgIcon, appIcon }
}

})